import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./TryFreeCTA.module.css";
import { getOnboardingUrl } from "../../utils/portalUrl";

// try_now_click is fired by the global click delegate in src/App.js,
// which catches every <a> pointing at portal.stylon.co/onboarding and
// reads utm_content for the source. No onClick handler needed here.

const TryFreeCTA = ({ centered = true, className = "", section = "cta_block" }) => {
  const { t } = useTranslation();

  return (
    <div className={`${styles.wrap} ${centered ? styles.centered : ""} ${className}`}>
      <a
        href={getOnboardingUrl(section)}
        className={styles.ctaLink}
      >
        <span className={styles.ctaButton}>
          {t("nav.startNow")}
        </span>
      </a>
    </div>
  );
};

export default TryFreeCTA;
